/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShopifyCommoditySyncResult
 */
export interface ShopifyCommoditySyncResult {
    /**
     * False when the company has no linked Shopify store (the sync was a no-op).
     * @type {boolean}
     * @memberof ShopifyCommoditySyncResult
     */
    linked: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShopifyCommoditySyncResult
     */
    totalProducts: number;
    /**
     * 
     * @type {number}
     * @memberof ShopifyCommoditySyncResult
     */
    stubsCreated: number;
    /**
     * 
     * @type {number}
     * @memberof ShopifyCommoditySyncResult
     */
    readyToQuote: number;
    /**
     * 
     * @type {number}
     * @memberof ShopifyCommoditySyncResult
     */
    needsDimensions: number;
}

/**
 * Check if a given object implements the ShopifyCommoditySyncResult interface.
 */
export function instanceOfShopifyCommoditySyncResult(value: object): value is ShopifyCommoditySyncResult {
    if (!('linked' in value) || value['linked'] === undefined) return false;
    if (!('totalProducts' in value) || value['totalProducts'] === undefined) return false;
    if (!('stubsCreated' in value) || value['stubsCreated'] === undefined) return false;
    if (!('readyToQuote' in value) || value['readyToQuote'] === undefined) return false;
    if (!('needsDimensions' in value) || value['needsDimensions'] === undefined) return false;
    return true;
}

export function ShopifyCommoditySyncResultFromJSON(json: any): ShopifyCommoditySyncResult {
    return ShopifyCommoditySyncResultFromJSONTyped(json, false);
}

export function ShopifyCommoditySyncResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopifyCommoditySyncResult {
    if (json == null) {
        return json;
    }
    return {
        
        'linked': json['linked'],
        'totalProducts': json['totalProducts'],
        'stubsCreated': json['stubsCreated'],
        'readyToQuote': json['readyToQuote'],
        'needsDimensions': json['needsDimensions'],
    };
}

  export function ShopifyCommoditySyncResultToJSON(json: any): ShopifyCommoditySyncResult {
      return ShopifyCommoditySyncResultToJSONTyped(json, false);
  }

  export function ShopifyCommoditySyncResultToJSONTyped(value?: ShopifyCommoditySyncResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'linked': value['linked'],
        'totalProducts': value['totalProducts'],
        'stubsCreated': value['stubsCreated'],
        'readyToQuote': value['readyToQuote'],
        'needsDimensions': value['needsDimensions'],
    };
}

